import React, { useState } from "react";
import axios from "axios";
import { RegionalApiManager, LoginType } from "src/scenes/App";
import { AuthBackButton, AuthDescription, AuthForm, AuthInput, AuthLink, AuthLinks, AuthPrimaryButton, AuthSurface, AuthTitle, ErrorLabel, LottieLoadingIndicator } from "src/components";
import ChevronLeft from "src/img/new/chevron-left.svg";
import { appFeatureLevels } from "src/constants/appFeatureLevels";
import { updateFeatureLevel } from "src/utils/appFeatures";
import { ErrorStrings } from "../Login";

const AccountOwnerLogin = ({ loginSuccess, showLoginSelection }) => {
    const [loading, setLoading] = useState(false);
    const [errorStrings, setErrorStrings] = useState([]);
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const errors = [];
        if (email.trim() === "") { errors.push(ErrorStrings.EMPTY_EMAIL); }
        if (password.trim() === "") { errors.push(ErrorStrings.EMPTY_PASSWORD); }
        if (errors.length) { setErrorStrings(errors); return; }
        setLoading(true); setErrorStrings([]);
        try {
            const regionData = await RegionalApiManager.locateUser(LoginType.CompanyAccount, email);
            const response = await axios.post(`${regionData.apiUrl}/company/accountLogin`, { email, password });
            RegionalApiManager.setRegionData(regionData);
            loginSuccess(regionData.region, response.data, { chatBackupPassphrase: password });
            updateFeatureLevel(appFeatureLevels.FEATURE_LEVEL_3, Intl.DateTimeFormat().resolvedOptions().timeZone, response.data.token);
        } catch (error) {
            console.error(error); setErrorStrings([error.getApiErrorDetails().message]); setLoading(false);
        }
    };
    return <AuthSurface><AuthBackButton type="button" onClick={showLoginSelection}><img alt="Back" src={ChevronLeft} /></AuthBackButton><AuthTitle>Account Owner Login</AuthTitle><AuthDescription>Sign in with your account owner email and password.</AuthDescription><AuthForm onSubmit={handleFormSubmit}><AuthInput placeholder="Email Address" autoComplete="email" type="email" onChange={event => setEmail(event.target.value)} disabled={loading} /><AuthInput placeholder="Password" autoComplete="current-password" type="password" onChange={event => setPassword(event.target.value)} disabled={loading} />{errorStrings.map(error => <ErrorLabel align="center" key={error}>{error}</ErrorLabel>)}{loading ? <LottieLoadingIndicator height="2rem" width="2rem" /> : <AuthPrimaryButton type="submit">Log In</AuthPrimaryButton>}</AuthForm><AuthLinks><AuthLink to="/forgotPassword/accountOwner">Forgot your password?</AuthLink></AuthLinks></AuthSurface>;
};

export default AccountOwnerLogin;
